import { EThresholdLevel } from '@web/entities/threshold/model/threshold-level.enum'
import severityColors from '@web/app/styles/core/severity-colors.module.css'
import type { TTheme } from '@web/shared/local-storage/theme.storage'

export const ThresholdLabel = {
  ControlEnabled: 'Контроль состояния',
  BaseRiftValue: 'Базовый уровень',
  RiftCalcEnabled: 'Автоматический расчёт',
  RiftCalcType: 'Вид расчёта',
  SkipLimit: 'Кол-во повторений',
  Coef: 'Коэффициент',
  Increment: 'Приращение',
  HysteresisCoef: 'Гистерезис',
  RiftValue: 'Граница',
  ResultsCount: 'Кол-во результатов',
  DaysDuration: 'Продолжительность, дней',
  BaseRiftValueAutoCorrectEnabled: 'Источник данных',
  CorrectionPeriodStart: 'Дата начала корректировки',
  CorrectionPeriodEnd: 'Дата оконч. корректировки'
} as const

export type TThresholdColorMap = Readonly<
  Record<EThresholdLevel, { soft: string; deep: string }>
>

// Хексы приходят из severity-colors.module.css (:export) — единственного
// источника цветов зон допускового контроля. soft одинаков в обеих темах
// (pie-chart, заливки графиков — важна насыщенность, а не контраст с текстом).
// Там, где soft/deep служат фоном под текстом (шапки аккордеонов, строки
// таблиц), текст явно фиксируется тёмным в месте использования — см.
// group-machines-accordions.tsx, machine-threshold-statistic.tsx.
const lightThresholdColors: TThresholdColorMap = {
  [EThresholdLevel.NONE]: {
    soft: severityColors.notSetSoft,
    deep: severityColors.notSetDeepLight
  },
  [EThresholdLevel.LEVEL_0]: {
    soft: severityColors.indefiniteSoft,
    deep: severityColors.indefiniteDeepLight
  },
  [EThresholdLevel.LEVEL_1]: {
    soft: severityColors.fineSoft,
    deep: severityColors.fineDeepLight
  },
  [EThresholdLevel.LEVEL_2]: {
    soft: severityColors.goodSoft,
    deep: severityColors.goodDeepLight
  },
  [EThresholdLevel.LEVEL_3]: {
    soft: severityColors.warningSoft,
    deep: severityColors.warningDeepLight
  },
  [EThresholdLevel.LEVEL_4]: {
    soft: severityColors.dangerSoft,
    deep: severityColors.dangerDeepLight
  }
}

const darkThresholdColors: TThresholdColorMap = {
  [EThresholdLevel.NONE]: {
    soft: severityColors.notSetSoft,
    deep: severityColors.notSetDeepDark
  },
  [EThresholdLevel.LEVEL_0]: {
    soft: severityColors.indefiniteSoft,
    deep: severityColors.indefiniteDeepDark
  },
  [EThresholdLevel.LEVEL_1]: {
    soft: severityColors.fineSoft,
    deep: severityColors.fineDeepDark
  },
  [EThresholdLevel.LEVEL_2]: {
    soft: severityColors.goodSoft,
    deep: severityColors.goodDeepDark
  },
  [EThresholdLevel.LEVEL_3]: {
    soft: severityColors.warningSoft,
    deep: severityColors.warningDeepDark
  },
  [EThresholdLevel.LEVEL_4]: {
    soft: severityColors.dangerSoft,
    deep: severityColors.dangerDeepDark
  }
}

export const mapThresholdColorByTheme: Readonly<
  Record<TTheme, TThresholdColorMap>
> = {
  light: lightThresholdColors,
  dark: darkThresholdColors
}
